const getSpeakerName = (speaker) => {
    const parts = [speaker.firstName, speaker.lastName].filter((p) => p !== null);
    return parts.join(' ');
};
const getDefaultRoleIndex = (speaker) => {
    var _a, _b, _c, _d;
    if (!speaker.savedInDb) {
        if (speaker.role === null) {
            return null;
        }
        return (_b = (_a = speaker.children) === null || _a === void 0 ? void 0 : _a.findIndex((r) => r.title === speaker.role)) !== null && _b !== void 0 ? _b : null;
    }
    return (_d = (_c = speaker.children) === null || _c === void 0 ? void 0 : _c.findIndex((r) => r.isDefault === true)) !== null && _d !== void 0 ? _d : null;
};
export const buildSpeakersTreeNode = (speaker) => {
    var _a, _b, _c, _d, _e;
    const defaultRoleIndex = getDefaultRoleIndex(speaker);
    const defaultRole = defaultRoleIndex !== null ? {
        title: (_c = (_b = (_a = speaker.children) === null || _a === void 0 ? void 0 : _a[defaultRoleIndex]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : '',
        index: defaultRoleIndex,
    } : null;
    return {
        speaker,
        name: getSpeakerName(speaker),
        defaultRole,
        rolesCount: (_e = (_d = speaker.children) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0,
        isExpanded: false,
        isPinned: false,
    };
};
